import React, { Component } from "react";
import { translate } from "react-i18next";

class EmployeeList extends Component {
	getImage(filename) {
		return "/src/images/employeelist/" + filename;
	}

	render() {
		const { t } = this.props;
		const url_lang = this.props.i18n.language === "en" ? "/en" : "";
		return (
			<div className="employeelist row">
				<div className="container">
					<div className="row">
						<div className="col-md-12">
							<hr style={{ marginTop: "0px" }} />
						</div>
					</div>
					<div className="row">
						<div className="col-md-12">
							<h1 className="gradient-txt no-margin">
								{t("DC_program_title1")}
							</h1>
							<h1 className="gradient-txt no-margin">
								{t("DC_program_title2")}
							</h1>
							<p className="main-subtitle">{t("DC_program_desc")}</p>
						</div>
						<a
							style={{ width: 150, marginLeft: "1.4rem" }}
							className="go-daycash-btn--link"
							href={`${url_lang}/contact`}
						>
							{this.props.t("contactus")}
							<span className="glyphicon glyphicon-arrow-right"></span>
						</a>
					</div>
				</div>
			</div>
		);
	}
}

export default translate("translations")(EmployeeList);



// WEBPACK FOOTER //
// ./src/components/common/employeelist.jsx